var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "red_packet" }, [
    _c("div", { staticClass: "packet_title" }, [
      _c("div", { staticClass: "packet_title_item" }, [
        _vm._m(0),
        _c("div", { staticClass: "packet_title_item_val" }, [
          _vm._v(" " + _vm._s(_vm._f("conversion")(_vm.user.recycles)) + " "),
        ]),
      ]),
      _c("div", { staticClass: "packet_title_item" }, [
        _c(
          "div",
          { staticClass: "packet_title_item_key" },
          [
            _c("c-svg", { staticClass: "icon", attrs: { src: "red-bag.svg" } }),
            _c("span", [_vm._v("红包币余额")]),
          ],
          1
        ),
        _c("div", { staticClass: "packet_title_item_val" }, [
          _vm._v(
            " " + _vm._s(_vm._f("conversion")(_vm.user.redPacketBalance)) + " "
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "balance_move" }, [
      _c("div", { staticClass: "balance_move_title" }, [_vm._v("转换红包币")]),
      _c("div", { staticClass: "balance_move_ext" }, [
        _c("div", { staticClass: "balance_move_box" }, [
          _c(
            "div",
            { staticClass: "item" },
            [
              _vm.move_type == 1
                ? _c("img", {
                    staticClass: "icon",
                    attrs: {
                      src: require("../../assets/images/home_new/KJ_currency.png"),
                    },
                  })
                : _vm._e(),
              _vm.move_type == 0
                ? _c("c-svg", {
                    staticClass: "icon",
                    attrs: { src: "red-bag.svg" },
                  })
                : _vm._e(),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm._f("conversion")(
                      _vm.move_type == 1
                        ? _vm.user.recycles
                        : _vm.user.redPacketBalance
                    )
                  )
                ),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "center", on: { click: _vm.onChangeMoveType } },
            [
              _c("c-svg", {
                staticClass: "icon",
                attrs: { src: "transfer.svg" },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "item" },
            [
              _vm.move_type == 0
                ? _c("img", {
                    staticClass: "icon",
                    attrs: {
                      src: require("../../assets/images/home_new/KJ_currency.png"),
                    },
                  })
                : _vm._e(),
              _vm.move_type == 1
                ? _c("c-svg", {
                    staticClass: "icon",
                    attrs: { src: "red-bag.svg" },
                  })
                : _vm._e(),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputQty,
                    expression: "inputQty",
                  },
                ],
                attrs: {
                  type: "number",
                  name: "qty",
                  min: _vm.setting.minRedPacketAmount,
                  max: _vm.setting.maxRedPacketAmount,
                  placeholder:
                    _vm.move_type == 1
                      ? "请输入红包币数量"
                      : "请输入商城币数量",
                },
                domProps: { value: _vm.inputQty },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.inputQty = $event.target.value
                  },
                },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "qty-tips" }, [
          _vm._v(
            "上限" +
              _vm._s(
                _vm._f("conversion")(
                  _vm.move_type == 1
                    ? Math.min(
                        _vm.user.recycles,
                        _vm.setting.canTransferToRedPacketAmount
                      )
                    : _vm.user.redPacketBalance
                )
              )
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "btn-recharge", on: { click: _vm.onMoveBalance } },
        [_c("span", { staticClass: "text" }, [_vm._v("转换")])]
      ),
    ]),
    _c("div", { staticClass: "line" }),
    _c("div", { staticClass: "balance_transfer" }, [
      _c("div", { staticClass: "balance_transfer_title" }, [
        _vm._v("赠送红包"),
      ]),
      _c("div", { staticClass: "balance_transfer_box" }, [
        _c("div", { staticClass: "to" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.target_id,
                expression: "target_id",
              },
            ],
            attrs: {
              type: "number",
              name: "target_id",
              min: "0",
              placeholder: "请输入赠送对象UID",
            },
            domProps: { value: _vm.target_id },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.target_id = $event.target.value
              },
            },
          }),
          _c(
            "div",
            { staticClass: "search", on: { click: _vm.onSearchUser } },
            [
              _c("c-svg", {
                staticClass: "icon",
                attrs: { src: "search.svg" },
              }),
            ],
            1
          ),
        ]),
        _vm.target_profile
          ? _c("div", { staticClass: "to_user" }, [
              _c("div", { staticClass: "avatar-con" }, [
                _c(
                  "div",
                  { staticClass: "avatar" },
                  [
                    _c("c-avatar", {
                      attrs: { src: _vm.target_profile.avatar, width: "100%" },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "info" }, [
                _c("div", { staticClass: "name-con" }, [
                  _c("span", { staticClass: "name" }, [
                    _vm._v("uid:" + _vm._s(_vm.target_profile.uid)),
                  ]),
                ]),
                _c("div", { staticClass: "name-con" }, [
                  _c("span", { staticClass: "name" }, [
                    _vm._v(_vm._s(_vm.target_profile.name)),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "qty" },
          [
            _c("c-svg", { staticClass: "icon", attrs: { src: "red-bag.svg" } }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inputAmount,
                  expression: "inputAmount",
                },
              ],
              staticStyle: { width: "80%" },
              attrs: {
                type: "number",
                min: _vm.setting.minRedPacketAmount,
                max: _vm.setting.maxRedPacketAmount,
                placeholder: "请输入红包金额",
              },
              domProps: { value: _vm.inputAmount },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.inputAmount = $event.target.value
                },
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "qty-tips" }, [
          _vm._v(
            " 上限" +
              _vm._s(
                _vm._f("conversion")(
                  Math.min(
                    _vm.user.redPacketBalance,
                    _vm.setting.maxRedPacketAmount
                  )
                )
              ) +
              " 下限" +
              _vm._s(
                _vm._f("conversion")(
                  Math.min(
                    _vm.user.redPacketBalance,
                    _vm.setting.minRedPacketAmount
                  )
                )
              ) +
              " "
          ),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "btn-recharge",
          class: _vm.transfer_ready ? "" : "disable",
          on: { click: _vm.onTransferRedPacket },
        },
        [_c("span", { staticClass: "text" }, [_vm._v("赠送")])]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "packet_title_item_key" }, [
      _c("img", {
        staticClass: "icon",
        attrs: { src: require("../../assets/images/home_new/KJ_currency.png") },
      }),
      _c("span", [_vm._v("商城币余额")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }